export { default } from './ReCaptchaV3';
